"use client"

import dynamic from "next/dynamic"
import { PopupLayout } from "@/components/common/popup/layout/PopupLayout"
import EventApply from "@/assets/lottie/event_apply.json"
import { PromotionEventPopupComponentProps } from "../EventConfig"

// 동적으로 import하고 SSR을 비활성화
const Lottie = dynamic(() => import("lottie-react"), { ssr: false })

const PromotionPopup418 = ({ onClose }: PromotionEventPopupComponentProps) => {
  return (
    <PopupLayout
      buttons={[
        {
          title: "확인",
          onClick: onClose,
        },
      ]}
    >
      <div className="flex flex-col items-center justify-center">
        <div className="flex h-[106px] w-[106px] items-center justify-center">
          <Lottie
            animationData={EventApply}
            loop={false}
            style={{ width: 106, height: 106 }}
          />
        </div>
        <span className="typo-rl-body2 mt-6 whitespace-break-spaces text-center text-rl-gray-font-press">
          {"이벤트 참여가\n완료되었습니다."}
        </span>
      </div>
    </PopupLayout>
  )
}

export default PromotionPopup418
